import React, { useState } from "react";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, DragEndEvent } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import SortableItem from "./SortableItem";
import { CheckItem } from "../../types/checkItem";
import { BsPlus } from "react-icons/bs";

type Props = {
  initialItems: CheckItem[];
};

const CheckListForm: React.FC<Props> = ({ initialItems }) => {
  const [items, setItems] = useState<CheckItem[]>(initialItems);

  const addItem = () => {
    const nextIndex = items.reduce((max, item) => Math.max(max, item.index), 0) + 1;
    setItems([...items, { index: nextIndex, label: "", type: "boolean", value: false }]);
  };

  const updateItem = (index: number, label: string) => {
    setItems(
      items.map((item) => {
        if (item.index === index) {
          return { ...item, label };
        }
        return item;
      }),
    );
  };

  const removeItem = (index: number) => {
    // item.id と渡ってきた index が合致している時にアイテムを削除する
    setItems(items.filter((item) => item.index !== index));
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (!over) {
      return;
    }

    if (active.id !== over.id) {
      const oldIndex = items.findIndex((v) => v.index === active.id);
      const newIndex = items.findIndex((v) => v.index === over.id);
      setItems(arrayMove(items, oldIndex, newIndex));
    }
  };

  return (
    <div className="card">
      <div className="card-body mb-0">
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
          modifiers={[restrictToVerticalAxis]}
        >
          <SortableContext items={items.map((i) => i.index)} strategy={verticalListSortingStrategy}>
            <ul className="m-0 p-0">
              {items.map((item) => (
                <SortableItem key={item.index} item={item} updateItem={updateItem} removeItem={removeItem} />
              ))}
            </ul>
          </SortableContext>
        </DndContext>
        <button
          type="button"
          className="btn btn-outline-primary d-flex align-items-center justify-content-center"
          onClick={addItem}
        >
          <BsPlus />
          追加
        </button>
        {/* Rails連携用 */}
        <input
          type="hidden"
          name="check_list[list]"
          id="check_list_list"
          value={JSON.stringify(
            // indexを振り直す
            items.map((item, index) => ({ ...item, index: index + 1 })),
          )}
        />
      </div>
    </div>
  );
};

export default CheckListForm;
